import { render, staticRenderFns } from "./ComponentsTab.vue?vue&type=template&id=b1ff0d6c&"
import script from "./ComponentsTab.vue?vue&type=script&lang=js&"
export * from "./ComponentsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/akryum/Projects/vue-devtools/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1ff0d6c')) {
      api.createRecord('b1ff0d6c', component.options)
    } else {
      api.reload('b1ff0d6c', component.options)
    }
    module.hot.accept("./ComponentsTab.vue?vue&type=template&id=b1ff0d6c&", function () {
      api.rerender('b1ff0d6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@vue-devtools/app-frontend/src/views/components/ComponentsTab.vue"
export default component.exports